// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OB7c8SXnx{position:relative;text-align:center;margin:auto}._6VnKkLuAx{position:absolute;top:calc(50% - 11px);left:calc(50% - 11px)}._6fDIIufjx{display:inline-block;vertical-align:middle;transition:opacity 80ms linear;text-indent:-99999px}.Eguyl5unx{max-width:24px;max-height:24px}._1QwXhskjx{width:24px}._1Y88DQpix{max-width:32px;max-height:32px}._2gAoXavwx{width:70px}._37B8Di4ox{width:170px}._6umUMqBfx{width:100%}._6eCsxiQMx{max-width:60px;max-height:60px}._5KSj1daMx{height:120px}\n", ""]);
// Exports
exports.locals = {
	"container": "OB7c8SXnx",
	"spinner": "_6VnKkLuAx",
	"frame": "_6fDIIufjx",
	"tiny": "Eguyl5unx _6fDIIufjx",
	"small": "_1QwXhskjx _6fDIIufjx",
	"medium": "_1Y88DQpix _6fDIIufjx",
	"large": "_2gAoXavwx _6fDIIufjx",
	"xlarge": "_37B8Di4ox _6fDIIufjx",
	"full": "_6umUMqBfx _6fDIIufjx",
	"fit": "_6eCsxiQMx _6fDIIufjx",
	"fitheight": "_5KSj1daMx _6fDIIufjx"
};
module.exports = exports;
